import { Order } from "../types/order.types";
import { ORDER_SUBSTATE } from "../types/state-order.types";

const LOGISTIC_NOT_CREATED = "NOT_CREATED";

export const isLogisticNotCreated = (order: Order): boolean => {
  const state = order.logisticState?.trim();
  if (!state) return true;
  return state.toUpperCase() === LOGISTIC_NOT_CREATED;
};

export const canCreateOrderShipment = (order: Order): boolean =>
  order.deliveryType === "delivery_home" &&
  isLogisticNotCreated(order) &&
  order.subState === ORDER_SUBSTATE.PACKAGED;

export const canViewOrderShipment = (order: Order): boolean =>
  order.deliveryType === "delivery_home" && !isLogisticNotCreated(order);
